export const slugify = (str = "") =>
  String(str)
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80) || "item";

export const findProductBySlug = (products = [], slug = "") =>
  products.find((p) => slugify(p.slug || p.name) === slug);
